module.exports = __webpack_public_path__ + "static/media/inscriptions1.cd7eeb53.png";